<script>
import { defineComponent as _defineComponent } from "vue";
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import {
  ref,
  provide,
  watch,
  toValue,
  onBeforeUnmount
} from "vue";
import { onClickOutside, onKeyStroke, usePointer } from "@vueuse/core";
import { Primitive } from "@maas/vue-primitive";
import { defu } from "defu";
import { useMenuState } from "../composables/private/useMenuState";
import { useMenuView } from "../composables/private/useMenuView";
import { useMenuKeyListener } from "../composables/private/useMenuKeyListener";
import { MagicMenuInstanceId } from "../symbols";
import { defaultOptions } from "../utils/defaultOptions";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicMenuProvider",
  props: {
    id: { type: null, required: true },
    asChild: { type: Boolean, required: false },
    options: { type: Object, required: false }
  },
  setup(__props) {
    const elRef = ref(void 0);
    const mappedOptions = defu(__props.options, defaultOptions);
    const { initializeState, deleteState } = useMenuState(__props.id);
    const state = initializeState(mappedOptions);
    const lastX = ref(0);
    const lastY = ref(0);
    const { x, y } = usePointer();
    watch(
      () => state?.input.type,
      (value) => {
        if (value === "keyboard") {
          lastX.value = x.value;
          lastY.value = y.value;
        }
      }
    );
    watch([x, y], ([x2, y2]) => {
      if (x2 !== lastX.value || y2 !== lastY.value) {
        if (state) {
          state.input.type = "pointer";
        }
      }
    });
    const {
      onArrowRight,
      onArrowLeft,
      onArrowUp,
      onArrowDown,
      onEscape,
      onEnter,
      onTab
    } = useMenuKeyListener(__props.id);
    onKeyStroke("ArrowRight", onArrowRight);
    onKeyStroke("ArrowLeft", onArrowLeft);
    onKeyStroke("ArrowDown", onArrowDown);
    onKeyStroke("ArrowUp", onArrowUp);
    onKeyStroke("Escape", onEscape);
    onKeyStroke("Enter", onEnter);
    onKeyStroke("Tab", onTab);
    const { unselectAllViews } = useMenuView(__props.id);
    onClickOutside(
      elRef,
      () => {
        if (state) {
          state.active = false;
        }
        unselectAllViews();
      },
      {
        ignore: [
          `[data-id='${toValue(__props.id)}'] .magic-menu-trigger`,
          `[data-id='${toValue(__props.id)}'] .magic-menu-item`,
          `.magic-menu-float`
        ]
      }
    );
    onBeforeUnmount(() => {
      deleteState();
    });
    provide(MagicMenuInstanceId, __props.id);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(Primitive), {
        ref_key: "elRef",
        ref: elRef,
        "as-child": _ctx.asChild,
        "data-id": _ctx.id,
        class: "magic-menu-provider"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["as-child", "data-id"]);
    };
  }
});
</script>

<style>
.magic-menu-provider {
  outline: none;
  user-select: none;
}
</style>
